import { errorToMessage } from '../../../errorMessaging';
import STATUS from '../../globalStatuses';
import { ACTIONS } from './types';

const parseWorkExperienceValue = preference => {
  try {
    const value = JSON.parse(preference?.value || 'null');
    if (value
      && Object.keys(value).every(key => ['workExperience', 'programOfferingId', 'workExperienceLevel'].includes(key))
      && (value.workExperienceLevel === undefined
        || ['NONE_YET', 'LESS_THAN_THREE_YEARS', 'THREE_OR_MORE_YEARS'].includes(value.workExperienceLevel))
      && ['YES', 'UNSELECTED'].includes(value.workExperience)
      && Object.prototype.hasOwnProperty.call(value, 'workExperience')
      && typeof value.programOfferingId === 'string'
      && value.programOfferingId
      && Object.prototype.hasOwnProperty.call(value, 'programOfferingId')) {
      return value;
    }
  } catch (error) {
    return {};
  }
  return {};
};

function preferences(
  // Redux reducers keep the conventional state-first signature with a default state.
  // eslint-disable-next-line default-param-last
  state = {
    preferences: {},
  },
  action,
) {
  switch (action.type) {
    // GET
    case ACTIONS.REQUEST_APP_EXPERIENCE:
      return {
        ...state,
        appExperienceStatus: {
          ...state.appExperienceStatus,
          getStatus: STATUS.FETCHING,
          errorData: null,
        },
      };
    case ACTIONS.RECEIVE_APP_EXPERIENCE:
      return {
        ...state,
        appExperience: action?.data?.id ? {
          id: action.data.id,
          value: JSON.parse(action.data.value).appExperience,
        } : {},
        appExperienceStatus: {
          ...state.appExperienceStatus,
          getStatus: STATUS.FETCHED,
        },
      };
    case ACTIONS.RECEIVE_APP_EXPERIENCE_ERROR:
      return {
        ...state,
        error: errorToMessage(action.error),
        appExperienceStatus: {
          ...state.appExperienceStatus,
          getStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };

    // POST & PUT
    case ACTIONS.REQUEST_POST_APP_EXPERIENCE:
    case ACTIONS.REQUEST_PUT_APP_EXPERIENCE:
      return {
        ...state,
        appExperienceStatus: {
          ...state.appExperienceStatus,
          modifyStatus: STATUS.UPDATING,
          errorData: null,
        },
      };
    case ACTIONS.RECEIVE_POST_APP_EXPERIENCE:
    case ACTIONS.RECEIVE_PUT_APP_EXPERIENCE:
      return {
        ...state,
        appExperienceStatus: {
          ...state.appExperienceStatus,
          modifyStatus: STATUS.UPDATED,
        },
      };
    case ACTIONS.RECEIVE_POST_APP_EXPERIENCE_ERROR:
    case ACTIONS.RECEIVE_PUT_APP_EXPERIENCE_ERROR:
      return {
        ...state,
        error: errorToMessage(action.error),
        appExperienceStatus: {
          ...state.appExperienceStatus,
          modifyStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };
    case ACTIONS.CLEAR_APP_EXPERIENCE_PATH_MODIFY_STATUS:
      return {
        ...state,
        appExperienceStatus: {
          ...state.appExperienceStatus,
          modifyStatus: STATUS.UNFETCHED,
        },
      };

    // C H O O S E   P A T H
    // GET
    case ACTIONS.REQUEST_CHOOSE_PATH:
      return {
        ...state,
        choosePath: {
          ...state.choosePath,
          personId: action.personId,
          id: state.choosePath?.personId === action.personId ? state.choosePath.id : '',
          value: state.choosePath?.personId === action.personId ? state.choosePath.value : {},
          choosePathStatus: {
            ...state.choosePath.choosePathStatus,
            getStatus: STATUS.FETCHING,
            errorData: null,
          },
        },
      };
    case ACTIONS.RECEIVE_CHOOSE_PATH:
      if (state.choosePath?.personId !== action.personId) return state;
      return {
        ...state,
        choosePath: {
          personId: action.personId,
          id: action?.data?.id || '',
          value: action?.data?.value ? JSON.parse(action.data.value) : {},
          choosePathStatus: {
            ...state.choosePath.choosePathStatus,
            getStatus: STATUS.FETCHED,
            errorData: null,
          },
        },
      };
    case ACTIONS.RECEIVE_CHOOSE_PATH_ERROR:
      if (state.choosePath?.personId !== action.personId) return state;
      return {
        ...state,
        choosePath: {
          personId: action.personId,
          id: '',
          value: {},
          choosePathStatus: {
            ...state.choosePath.choosePathStatus,
            getStatus: STATUS.ERROR,
            errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
          },
        },
      };
    // W O R K   E X P E R I E N C E
    case ACTIONS.REQUEST_WORK_EXPERIENCE:
      return {
        ...state,
        workExperience: {
          ...state.workExperience,
          personId: action.personId,
          id: state.workExperience?.personId === action.personId
            ? state.workExperience.id : '',
          value: state.workExperience?.personId === action.personId
            ? state.workExperience.value : {},
          workExperienceStatus: {
            ...state.workExperience?.workExperienceStatus,
            getStatus: STATUS.FETCHING,
            errorData: null,
          },
        },
      };
    case ACTIONS.RECEIVE_WORK_EXPERIENCE:
      if (state.workExperience?.personId !== action.personId) return state;
      return {
        ...state,
        workExperience: {
          personId: action.personId,
          id: action.data?.id || '',
          value: parseWorkExperienceValue(action.data),
          workExperienceStatus: {
            ...state.workExperience?.workExperienceStatus,
            getStatus: STATUS.FETCHED,
            errorData: null,
          },
        },
      };
    case ACTIONS.RECEIVE_WORK_EXPERIENCE_ERROR:
      if (state.workExperience?.personId !== action.personId) return state;
      return {
        ...state,
        workExperience: {
          ...state.workExperience,
          workExperienceStatus: {
            ...state.workExperience?.workExperienceStatus,
            getStatus: STATUS.ERROR,
            errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
          },
        },
      };
    case ACTIONS.REQUEST_SAVE_WORK_EXPERIENCE:
      if (state.workExperience?.personId !== action.personId) return state;
      return {
        ...state,
        workExperience: {
          ...state.workExperience,
          workExperienceStatus: {
            ...state.workExperience?.workExperienceStatus,
            modifyStatus: STATUS.UPDATING,
            errorData: null,
          },
        },
      };
    case ACTIONS.RECEIVE_SAVE_WORK_EXPERIENCE:
      if (state.workExperience?.personId !== action.personId) return state;
      return {
        ...state,
        workExperience: {
          personId: action.personId,
          id: action.data?.id || state.workExperience.id,
          value: parseWorkExperienceValue(action.data),
          workExperienceStatus: {
            ...state.workExperience?.workExperienceStatus,
            getStatus: STATUS.FETCHED,
            modifyStatus: STATUS.UPDATED,
            errorData: null,
          },
        },
      };
    case ACTIONS.RECEIVE_SAVE_WORK_EXPERIENCE_ERROR:
      if (state.workExperience?.personId !== action.personId) return state;
      return {
        ...state,
        workExperience: {
          ...state.workExperience,
          workExperienceStatus: {
            ...state.workExperience?.workExperienceStatus,
            modifyStatus: STATUS.ERROR,
            errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
          },
        },
      };
    // POST & PUT
    case ACTIONS.REQUEST_POST_CHOOSE_PATH:
    case ACTIONS.REQUEST_PUT_CHOOSE_PATH:
      return {
        ...state,
        choosePath: {
          ...state.choosePath,
          choosePathStatus: {
            ...state.choosePath.choosePathStatus,
            modifyStatus: STATUS.UPDATING,
            errorData: null,
          },
        },
      };
    case ACTIONS.RECEIVE_POST_CHOOSE_PATH:
    case ACTIONS.RECEIVE_PUT_CHOOSE_PATH:
      return {
        ...state,
        choosePath: {
          ...state.choosePath,
          id: action?.data?.id || '',
          value: action?.data?.value ? JSON.parse(action.data.value) : {},
          choosePathStatus: {
            ...state.choosePath.choosePathStatus,
            modifyStatus: STATUS.UPDATED,
            errorData: null,
          },
        },
      };
    case ACTIONS.RECEIVE_POST_CHOOSE_PATH_ERROR:
    case ACTIONS.RECEIVE_PUT_CHOOSE_PATH_ERROR:
      return {
        ...state,
        choosePath: {
          ...state.choosePath,
          id: '',
          value: {},
          choosePathStatus: {
            ...state.choosePath.choosePathStatus,
            modifyStatus: STATUS.ERROR,
            errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
          },
        },
      };

    // Feature Flags
    // GET
    case ACTIONS.REQUEST_FEATURE_FLAGS:
      return {
        ...state,
        featureFlagsStatus: {
          ...state.featureFlagsStatus,
          getStatus: STATUS.FETCHING,
          errorData: null,
        },
      };
    case ACTIONS.RECEIVE_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action?.data?.id ? {
          id: action.data.id,
          value: JSON.parse(action.data.value),
          createdDate: action?.data?.createdDate,
        } : {},
        featureFlagsStatus: {
          ...state.featureFlagsStatus,
          getStatus: STATUS.FETCHED,
        },
      };
    case ACTIONS.RECEIVE_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        error: errorToMessage(action.error),
        featureFlagsStatus: {
          ...state.featureFlagsStatus,
          getStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };

    // POST & PUT
    case ACTIONS.REQUEST_POST_FEATURE_FLAGS:
    case ACTIONS.REQUEST_PUT_FEATURE_FLAGS:
      return {
        ...state,
        featureFlagsStatus: {
          ...state.featureFlagsStatus,
          modifyStatus: STATUS.UPDATING,
          errorData: null,
        },
      };
    case ACTIONS.RECEIVE_POST_FEATURE_FLAGS:
    case ACTIONS.RECEIVE_PUT_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action?.data?.id ? {
          id: action.data.id,
          value: JSON.parse(action.data.value),
        } : {},
        featureFlagsStatus: {
          ...state.featureFlagsStatus,
          modifyStatus: STATUS.UPDATED,
        },
      };
    case ACTIONS.RECEIVE_POST_FEATURE_FLAGS_ERROR:
    case ACTIONS.RECEIVE_PUT_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        error: errorToMessage(action.error),
        featureFlagsStatus: {
          ...state.featureFlagsStatus,
          modifyStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };

    case ACTIONS.CLEAR_CHOOSE_PATH_MODIFY_STATUS:
      return {
        ...state,
        choosePath: {
          ...state.choosePath,
          choosePathStatus: {
            ...state.choosePath.choosePathStatus,
            modifyStatus: STATUS.UNFETCHED,
          },
        },
      };

    case 'STORE_PROCESSED_FLAGS':
      return {
        ...state,
        processedFeatureFlags: action.payload,
        featureFlags: {
          ...state.featureFlags,
          value: {
            ...state.featureFlags?.value,
            flags: {
              ...(state.featureFlags?.value?.flags || {}),
            },
          },
        },
      };

    default:
      return state;
  }
}

export default preferences;
